export default function getAppVersion(): string {
  return process.env.NEXT_PUBLIC_CLIENT_VERSION ?? 'unknown';
}
